import algoliasearch from "algoliasearch/lite"
import {createRef, default as React, useState} from "react"
import {InstantSearch} from "react-instantsearch-dom"
import StyledSearchBox from "./styled-search-box"
import StyledSearchResult from "./styled-search-result"
import StyledSearchRoot from "./styled-search-root"
import {useClickOutside} from "../../hooks"
import {useMenuContext} from "../../state"

const algoliaClient = algoliasearch(
  'D35FRZRZTE',
  '4eaec0ca14a4d243e5ca0bb413dd9379',
)

const searchClient = {
  ...algoliaClient,
  search(requests) {
    if (requests.every(({params}) => !params.query || params.query.length < 3)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          processingTimeMS: 0,
        })),
      })
    }
    return algoliaClient.search(requests)
  },
}

export default function Search({className}) {
  const rootRef = createRef()
  const [query, setQuery] = useState()
  const [hasFocus, setFocus] = useState()
  const {isMenuOpen} = useMenuContext()

  useClickOutside(rootRef, () => setFocus(false))

  const customIndices = [{
    name: 'netlify_7ece2cb5-5d54-47de-b4cb-b926056c56d4_master_all',
    title: 'all',
  }]

  return (
    <StyledSearchRoot ref={rootRef} className={className}>
      <InstantSearch
        searchClient={searchClient}
        indexName={'netlify_7ece2cb5-5d54-47de-b4cb-b926056c56d4_master_all'}
        onSearchStateChange={({query}) => setQuery(query)}
      >
        <StyledSearchBox
          onFocus={() => setFocus(true)}
          hasFocus={hasFocus}
          isMenuOpen={isMenuOpen}
        />
        <StyledSearchResult
          show={query && query.length >= 3 && hasFocus}
          indices={customIndices}
          hideResults={() => setFocus(false)}
        />
      </InstantSearch>
    </StyledSearchRoot>
  )
}
